import { Helmet } from "react-helmet-async";
import seoConfig from "./seo/seoConfig";

const { BASE_URL, SITE_NAME, DEFAULT_DESC } = seoConfig;

export default function SEO({ title, description, path = "" }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
  const desc = description || DEFAULT_DESC;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
}
